<template lang="pug">
b-modal#editDefaultTemplate(
  ref="editDefaultTemplate"
  :title="$t('ui.combine.edit_mini_game_template')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.template_code')").mb-1
      DebounceInput(
        size="sm"
        ref="template_code"
        required
        type="text"
        :dirty="$v.template_code.$dirty"
        :error="$v.template_code.$error"
        v-model.trim.lazy="$v.template_code.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.template_code" :name="$t('ui.template_code')")
    b-form-group(:label="$t('ui.template_name')").mb-1
      DebounceInput(
        size="sm"
        ref="template_name"
        required
        type="text"
        :dirty="$v.template_name.$dirty"
        :error="$v.template_name.$error"
        v-model.trim.lazy="$v.template_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.template_name" :name="$t('ui.template_name')")

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import config from "@/config";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      template_code: '',
      template_name: '',
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    template_code: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(30)
    },
    template_name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    }
  },
  methods: {
    done(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editDefaultTemplateUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          template_code: this.item.template_code,
          new_template_code: this.template_code,
          template_name: this.template_name,
        };
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_mini_game_template", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.editDefaultTemplate.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.editDefaultTemplate.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = response.data.status;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.template_code = "";
      this.template_name = "";
    },
    shown() {
      this.$v.$reset();
      this.template_code = this.item.template_code;
      this.template_name = this.item.template_name;
      this.$refs.template_code.$el.focus();
    }
  }
};
</script>
